import React from 'react';
import { Shield, Navigation, Bell, BarChart3, GitBranch, Upload } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
import { themeClasses } from '../../config/themeClasses';

const FEATURES = [
  { icon: Shield, titleKey: 'landingFeature1Title', descKey: 'landingFeature1Desc' },
  { icon: Navigation, titleKey: 'landingFeature2Title', descKey: 'landingFeature2Desc' },
  { icon: Bell, titleKey: 'landingFeature3Title', descKey: 'landingFeature3Desc' },
  { icon: BarChart3, titleKey: 'landingFeature4Title', descKey: 'landingFeature4Desc' },
  { icon: GitBranch, titleKey: 'landingFeature5Title', descKey: 'landingFeature5Desc' },
  { icon: Upload, titleKey: 'landingFeature6Title', descKey: 'landingFeature6Desc' },
];

export default function LandingFeatureGrid() {
  const { t } = useLocale();

  return (
    <section className={themeClasses.landing.section}>
      <div className={themeClasses.landing.container}>
        <h2 className="text-display-lg mx-auto max-w-2xl text-center">{t('landingFeatureTitle')}</h2>
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map(({ icon: Icon, titleKey, descKey }) => (
            <article key={titleKey} className={themeClasses.landing.featureCard}>
              <div className={themeClasses.appKit.emptyIconTile}>
                <Icon className="size-6 text-brand-600" aria-hidden />
              </div>
              <h3 className="mt-4 text-lg font-semibold tracking-tight text-text-primary">
                {t(titleKey)}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-text-secondary">{t(descKey)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
